import { useMutation } from 'react-query';
import { updateRegisterResult } from 'apis/registerResult';

const useMutationUpdateRegisterResult = () => {
  const { mutateAsync, ...rest } = useMutation(({ id, data }) => updateRegisterResult(id, data));

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationUpdateRegisterResult;
